import { ErrorMessage } from 'components/Widgets/ErrorMessage';
import { getApiErrorMessage } from 'services/_infra/apiError.utils';
import ForecastAdvisoryList from '../../components/ForecastAdvisoryList/ForecastAdvisoryList';
import { DEFAULT_FORECAST_ADVISORY_DISTANCE_MILES } from '../../config/forecastAdvisories.config';

const ForecastAdvisoriesWidget = ({ alerts, error, isError, mode, onRetry }) => {
  if (isError && !alerts.length) {
    return <ErrorMessage message={getApiErrorMessage(error)} onRetry={onRetry} />;
  }

  return (
    <section
      aria-label="Forecast advisories widget"
      className="d-flex h-100 min-h-0 w-100 flex-column overflow-hidden"
    >
      {isError && (
        <div className="alert alert-warning m-0 py-2" role="alert">
          Update failed. Showing the most recently available advisories.
        </div>
      )}

      <div className="min-h-0 flex-grow-1 overflow-auto">
        <ForecastAdvisoryList
          alerts={alerts}
          maximumDistanceMiles={DEFAULT_FORECAST_ADVISORY_DISTANCE_MILES}
          mode={mode}
        />
      </div>
    </section>
  );
};

export default ForecastAdvisoriesWidget;
